import React, { useContext, useEffect, useState } from 'react';
import { store } from '../reducer';
import axios from '../../../../../api/axios';
import { makeStyles } from '@material-ui/core/styles';
import DataGrid from '../../../../../components/DataGrid/DataGrid';
import moment from 'moment-jalaali';
import Avatar from '../../../../../components/User/UserAvatar';
import { Link, useHistory } from 'react-router-dom';
import { __ } from '../../../../../utils/i18n';
import { localText } from '../../../../../langs/fa/data-grid';
import DatePicker from '../../../../../components/TextFields/DatePicker';
import useTitle from 'hooks/useTitle';
import RejectedFilters from './Filters';
import { isMobile } from 'react-device-detect';
import FullCard from 'components/Card/FullCard';
import { useQuery } from 'react-query';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .list': {
      height: !isMobile ? 480 : '',
    },
    position: 'relative',
    width: '100%',
    '& .pending': {
      background: '#ffecb3',
    },
    '& .tendering': {
      background: '#e6ee9c',
    },
    '& .getWaybill': {
      background: '#bbdefb',
    },
    '& .rejected': {
      background: '#e0e0e0',
    },
    '& .loadTime': {
      fontSize: 12,
    },
    '& .colHeader': {
      background: '#607d8b',
      color: '#fff',
    },
  },
  fleetCount: {
    '& > span.red': {
      background: '#dd2c00',
      color: '#fff',
      padding: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    '& > span.green': {
      background: '#76ff03',
      padding: theme.spacing(1),
    },
  },
  datePickerContainer: {
    position: 'absolute',
    bottom: 5,
    left: 5,
    width: 300,
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: theme.spacing(1),
  },
}));

const Returns = () => {
  useTitle('گزارش سفارش های برگشت خورده');
  const classes = useStyles();
  const {
    state,
    dispatch,
    showMessage,
    showError,
    itemsCountPerPage,
  } = useContext(store);
  const columns = [
    {
      field: 'loadingDate',
      headerName: 'بارگیری',
      width: 100,
      renderCell: ({ value }) => moment(value.loadDate).format('jYY/jMM/jDD'),
      cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
    {
      field: 'customer',
      headerName: 'صاحب‌بار',
      flex: 1,
      renderCell: ({ value: { customer } }) => (
        <Avatar user={customer} fullName width={30} height={30} />
      ),
      cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
    {
      field: 'origin',
      headerName: 'مبدا',
      width: 100,
      renderCell: ({ value: { origin } }) => origin.title,
      cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
    {
      field: 'fleetOptions',
      headerName: 'ناوگان',
      flex: 1,
      renderCell: ({ value: { fleetOptions } }) =>
        fleetOptions.map((f) => `${f.fleet.title}(${f.title})`).join('، '),
      cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
    {
      field: 'fleetCount',
      headerName: 'تعداد ناوگان',
      width: 150,
      renderCell: ({ value: { _id, fleetCount, drivers } }) => {
        if (fleetCount === 1)
          return <Link to={`/protected/admin/orders/${_id}#fleets`}>1</Link>;
        else
          return (
            <Link to={`/protected/admin/orders/${_id}#fleets`}>
              <div className={classes.fleetCount}>
                <span className="red">مانده:{fleetCount - drivers.length}</span>
                <span className="green">آماده:{drivers.length}</span>
              </div>
            </Link>
          );
      },
      cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
    {
      field: 'destination',
      headerName: 'مقصد',
      width: 100,
      renderCell: ({ value: { destination } }) => destination.title,
      cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
    {
      field: 'loadingTime',
      headerName: 'زمان‌بارگیری',
      width: 120,
      renderCell: ({ value: { loadTime } }) => __(loadTime),
      cellClassName: ({ value: { status } }) => `${status} loadTime`,
      headerClassName: 'colHeader',
    },
    {
      field: 'loadType',
      headerName: 'محموله',
      width: 100,
      renderCell: ({ value: { cargos } }) => cargos?.[0]?.type?.title,
      cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
    {
      field: 'packaging',
      headerName: 'بسته‌بندی',
      width: 100,
      renderCell: ({ value: { cargos } }) =>
        cargos?.[0]?.packaging?.title || '-',
      cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
    {
      field: 'status',
      headerName: 'وضعیت',
      width: 100,
      renderCell: ({ value: { status } }) => __(status),
      cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
  ];
  const [values, setValues] = useState({
    page: 1,
    orders: null,
    loading: true,
    fromDate: moment(),
    toDate: moment(),
    selectedUser: null,
  });
  const { page, loading, orders, fromDate, toDate, selectedUser } = values;
  const history = useHistory();

  const handlePageChange = async ({ page }) => {
    setValues({ ...values, page });
  };
  const handleSelectOrder = ({ row, field }) => {
    const { id } = row;
    const fields = ['customer', 'fleetCount'];
    if (fields.includes(field)) return;
    history.push(`/protected/admin/orders/${id}`);
  };

  const loadReturned = async () => {
    try {
      const { data } = await axios.post(`/api/v1/admin/reports/returned`, {
        page,
        limit: itemsCountPerPage,
        fromDate,
        toDate,
        customer: selectedUser?._id,
      });
      setValues({ ...values, orders: data?.returned, loading: false });
      return data?.returned;
    } catch (error) {
      showError(error);
    }
  };

  useEffect(() => {
    dispatch({
      type: 'CHANGE_TITLE_CATEGORY',
      payload: {
        title: 'گزارش سفارش‌های برگشت خورده',
        category: 'گزارش سفارشاتی که در روز جاری برگشت بار خورده اند',
      },
    });
  }, []);

  // useEffect(() => {
  //   loadRejects();
  // }, [fromDate, toDate]);

  const { data, isLoading } = useQuery(
    ['loadReturnedOrders', fromDate, toDate, selectedUser],
    loadReturned,
    { refetchOnWindowFocus: false }
  );

  return (
    <div className={classes.root}>
      <FullCard className={'pt-1'} divider={false}>
        <RejectedFilters
          fromDate={fromDate}
          toDate={toDate}
          setValues={setValues}
          values={values}
        />
        <div className="list">
          <DataGrid
            rows={
              data?.docs?.map
                ? data.docs.map((order) => ({
                    id: order._id,
                    loadingDate: order,
                    customer: order,
                    origin: order,
                    fleetOptions: order,
                    fleetCount: order,
                    destination: order,
                    loadingTime: order,
                    loadType: order,
                    packaging: order,
                    status: order,
                  }))
                : []
            }
            columns={columns}
            localeText={localText}
            pageSize={itemsCountPerPage}
            rowCount={data && data.totalDocs ? data.totalDocs : 0}
            paginationMode="server"
            onPageChange={handlePageChange}
            loading={isLoading}
            disableMultipleSelection
            onCellClick={handleSelectOrder}
            density="compact"
            // onSelectionChange={handleSelectOrder}
          />
        </div>
      </FullCard>
    </div>
  );
};

export default Returns;
